import React, {Component} from 'react';
//path途径、company单位、widthAndHeight尺寸、format格式、fileSize大小、fileTime时间、jurisdiction权限、status状态、duration时长
export const optionConfig = {
    "public": {
        "picture": ["path", "company", "widthAndHeight", "format", "fileSize", "fileTime"],
        "video": ["path", "company", "duration", "format", "fileSize", "fileTime"],
        "audio": ["path", "company", "duration", "format", "fileSize", "fileTime"],
        "other_file": ["path", "company", "format", "fileSize", "fileTime"]
    },
    "all": {
        "picture": ["path", "company", "widthAndHeight", "format", "fileSize", "fileTime", "status"],
        "video": ["path", "company", "duration", "format", "fileSize", "fileTime", "status"],
        "audio": ["path", "company", "duration", "format", "fileSize", "fileTime", "status"],
        "other_file": ["path", "company", "format", "fileSize", "fileTime", "status"]
    },
    "dept": {
        "picture": ["path", "widthAndHeight", "format", "fileSize", "fileTime", "status"],
        "video": ["path", "duration", "format", "fileSize", "fileTime", "status"],
        "audio": ["path", "duration", "format", "fileSize", "fileTime", "status"],
        "other_file": ["path", "format", "fileSize", "fileTime", "status"]
    },
    "person": {
        "picture": ["path", "widthAndHeight", "format", "fileSize", "fileTime", "status"],
        "video": ["path", "duration", "format", "fileSize", "fileTime", "status"],
        "audio": ["path", "duration", "format", "fileSize", "fileTime", "status"],
        "other_file": ["path", "format", "fileSize", "fileTime", "status"]
    }
}